import React from 'react';
import compose from 'lodash/flowRight';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import withProps from './withProps.js';

const Map = ({ marker }) => (
  <GoogleMap
  defaultZoom={15}
  defaultCenter={latLng(marker)}
  center={latLng(marker)}
  >
    <Marker
      position={latLng(marker)}
      icon={{
        url: "/themes/app/assets/images/map-marker.svg"
      }}
    />
  </GoogleMap>
);

const latLng = ({ latitude, longitude }) => ({
  lat: format(latitude),
  lng: format(longitude),
});

const format = (value) => {
  const multiplier = Math.pow(10, 7 || 0);
  return Math.round(value * multiplier) / multiplier;
};

export default compose(
  withProps(props => ({
    ...props,
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${props.apiKey}&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: `100%`, }} />,
    containerElement: <div className="c-OfficeMap" />,
    mapElement: <div style={{ height: `100%` }} />,
  })),
  withScriptjs,
  withGoogleMap,
)(Map);



// WEBPACK FOOTER //
// ./plugins/app/site/pagesections/officetabs/js/OfficeMap.js